import { render, staticRenderFns } from "./AuthNotificationShow.vue?vue&type=template&id=4a4b672b&"
import script from "./AuthNotificationShow.vue?vue&type=script&lang=js&"
export * from "./AuthNotificationShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports